import UserContext from 'contexts/UserContext'
import React, { useContext, useEffect, useState } from 'react'
import iconAddBnf from '../../assets/iconAddBnf.svg'
import iconRecemmentEnvoye from '../../assets/iconRecemmentEnvoye.svg'

import { Spinner } from 'utils/loading'
import { getListBeneficary } from 'requests/benificary'
import ModalAddBeneficiary from 'containers/beneficiaireContainer/modalAddBeneficiary'

import { Link } from 'react-router-dom'
import { BeneficiaryType } from 'types/beneficiary'

import { useTranslation } from 'react-i18next'
import { userLatsTransfers } from 'requests/transfer'
import ModalBeneficiaryServices from 'containers/beneficiaireContainer/ModalBeneficiaryServices'
import BeneficiaryContext from 'contexts/beneficiaryContext'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import Avatar from 'components/avatar'
const ContainerHome = () => {
  const [listBeneficiaries, setListBeneficiaries] = useState<BeneficiaryType[]>()
  const [transactionData, setTransactionData] = useState<BeneficiaryType[]>()

  const { user } = useContext(UserContext)
  const { setBeneficiaries, beneficiaries } = useContext(BeneficiaryContext)
  const { TransferDataBeneficiary } = useContext(transferBeneficiaryContext)

  const [loading, setLoading] = useState(false)
  const [isAdded, setIsAdded] = useState(false)
  const [openModalServices, setOpenModalServices] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { t } = useTranslation()

  const openModal = () => {
    setIsModalOpen(true)
  }

  useEffect(() => {
    async function fetchData() {
      const id = user?.user?._id
      const token = user?.token?.accessToken
      try {
        const response = await getListBeneficary(id, token)
        const responseT = await userLatsTransfers(id, token)

        if (response?.success === true) {
          setListBeneficiaries(response?.beneficiaries)
          setLoading(true)
        }
        if (responseT?.success === true) {
          setTransactionData(responseT.transfers)
        }
      } catch (error) {
        console.error(error)
      }
    }
    if (user) {
      fetchData()
    }
  }, [user, isAdded, TransferDataBeneficiary])

  if (!loading) return <Spinner name="line-scale-pulse-out-rapid" color="#1466ff" />

  return (
    <div className="flex flex-col gap-[40px] mt-8 lg:mt-0">
      <div className="flex flex-col gap-1">
        <div className="flex justify-between  items-center w-full ">
          <h2 className="font-bold cursor-default font-poppins text-[21px] text-[#0A0A0A]  ">{t('detailsRightDash.recentlySent')}</h2>
          {transactionData && transactionData.length !== 0 && (
            <Link className={` text-[#B4B4B4] text-[16px] `} to={'/history'}>
              {t('detailsRightDash.viewAll')}
            </Link>
          )}
        </div>

        {transactionData && transactionData.length === 0 ? (
          <div className="border-dotted border-2 border-[#5754E5] rounded-lg py-4 gap-2 flex flex-col items-center justify-center">
            <img src={iconRecemmentEnvoye} width={48} height={53} />
            <div className="text-[#808091] font-medium text-[10px] font-roboto w-[200px] text-center">
              {t('detailsRightDash.noServicesYet')}
            </div>
          </div>
        ) : (
          <div className="flex mt-4 gap-[4%] lg:gap-[6%] items-center justify-start max-w-[340px] scrollbar-webkit overflow-x-auto">
            {transactionData &&
              transactionData
                .slice(0, 5)
                .map((item: any, index: number) => (
                  <Avatar
                    styleCss="w-[50px]"
                    key={index}
                    avatar={item?.recipient?.avatar}
                    lastName={item?.recipient?.personalInfo?.lastName}
                  />
                ))}
          </div>
        )}
      </div>

      <div className="flex flex-col gap-1">
        <div className="flex justify-between  items-center w-full">
          <h2 className="font-bold cursor-default font-poppins text-[21px] text-[#0A0A0A]  ">
            {t('detailsRightDash.myBeneficiaries')}
          </h2>
          {listBeneficiaries && listBeneficiaries.length !== 0 && (
            <Link
              className={`${listBeneficiaries && listBeneficiaries.length === 0 ? 'hidden' : 'block'} text-[#B4B4B4] text-[16px] `}
              to={'/beneficiary'}
            >
              {t('detailsRightDash.viewAll')}
            </Link>
          )}
        </div>
        <div className="flex flex-col items-start mt-3 gap-3 overflow-x-auto w-full mx-auto">
          {listBeneficiaries && listBeneficiaries.map((item: any, index: number) => (
            <div
            className='cursor-pointer'
              key={index}
              onClick={() => {
                setOpenModalServices(true)
                setBeneficiaries(item)
              }}
            >
              <Avatar
                afficheName={true}
                styleCss="w-[52px] h-[52px] mb-2"
                lastName={item?.personalInfo?.firstName}
                name={item?.personalInfo?.firstName}
                num={`+${item?.personalInfo?.phone.prefix} ${item?.personalInfo?.phone.number}`}
                avatar={item.avatar}
              />
            </div>
          ))}
          <div className=" flex items-center  gap-6  ">
            <img src={iconAddBnf} className=" cursor-pointer object-cover mb-2" width={52} height={52} onClick={openModal} />
            <div className="text-[18px] cursor-default  text-center font-medium text-[#5754E5]">Nouveau bénéficiaire</div>
          </div>
        </div>
      </div>

      {beneficiaries && openModalServices && (
        <ModalBeneficiaryServices selectedBeneficiary={beneficiaries} setAction={setOpenModalServices} />
      )}

      {isModalOpen && <ModalAddBeneficiary setIsOpen={setIsModalOpen} setIsBeneficiaryAdded={setIsAdded} />}
    </div>
  )
}

export default ContainerHome
